import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function mobileAppGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const hasMobileApp = store.getters['subscription/isMobileAppPurchased']

  if (!hasMobileApp) return next({ name: 'billing:plans' })

  return next()
}

export default mobileAppGuard
